import * as React from 'react';

import { TextInput } from './TextInput';
import { Button } from './buttons/Button';

interface ProductSearchBarProps {
  localSearchText: string;
  setLocalSearchText: (text: string) => void;
  setCurrentSearchText: (text: string) => void;
}

export const ProductSearchBar = ({
  localSearchText,
  setLocalSearchText,
  setCurrentSearchText,
}: ProductSearchBarProps) => {
  const onSearch = () => setCurrentSearchText(localSearchText.trim());

  return (
    <div className="flex items-center gap-4 mb-4">
      <div className="flex items-center">
        <TextInput
          className="w-[150px] mr-[10px] !text-sm"
          label=""
          placeholder=""
          setTextChange={setLocalSearchText}
          value={localSearchText}
          onEnter={onSearch}
        />
        <div className="flex items-center justify-center">
          <Button label="Search" onClick={onSearch} textClassName="text-sm" />
        </div>
      </div>
    </div>
  );
};
